// extracted by mini-css-extract-plugin
module.exports = {"container":"TextContainer_container__33qRP","buttons":"TextContainer_buttons__2f8At","icon-container":"TextContainer_icon-container__32QkG"};